import * as React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import * as S from './styles';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { TCButton } from 'components/TCButton';   
import { ISelectRatingsProps, IRatingInfo } from './types';
import { Provider as ProviderType, Widgets, ProviderRating} from '../../../state/types';
import { RootState } from 'store/types';
import { cloneDeep } from 'lodash';
import { saveWidgetsConfig } from '../../../state/utils';
import FilterCheck from 'components/Filter';

const SelectRatings: React.FC<ISelectRatingsProps> = (props) => {
    const [ratingsInformation, setRatingsInformation] = React.useState<IRatingInfo[]>([]);
    const [saving, setSaving] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');

    const componentRef = React.useRef(null);
    const dispatch = useDispatch();

    const {
        widgets,
        selectedDealerId
    } = useSelector((rootState: RootState) => {
        return {
            widgets: rootState.reviews.widgets,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
        }
    }, shallowEqual);

    React.useEffect(() => {
        let updateRatingsInformation: IRatingInfo[] = [{rating: 5, selected: true}, {rating: 4, selected: true}, {rating: 3, selected: true}, {rating: 2, selected: true}, {rating: 1, selected: true}];
        if (props.widgetsConfig && props.widgetsConfig.reviewList.ratingOptions) {
            updateRatingsInformation.forEach((ratingInfo: IRatingInfo) => {
                if (!props.widgetsConfig.reviewList.ratingOptions!.includes(ratingInfo.rating)) {
                    ratingInfo.selected = false;
                }    
            });
        }
        setRatingsInformation(updateRatingsInformation);
    }, [props.widgetsConfig, props.selectedTab]);

    const handleClickOutside = (e: any) => {
        if (componentRef && componentRef.current) {
            const ref: any = componentRef.current
            if (!ref.contains(e.target)) props.onClose();
        }
    }

    React.useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [])

    const saveRatingsInformation = async () => {
        let newRatingsList = ratingsInformation.filter((ratingInfo: IRatingInfo) => ratingInfo.selected).map((ratingInfo: IRatingInfo) => ratingInfo.rating);
        let updateWidgets: Widgets|undefined = cloneDeep(widgets);
        if (updateWidgets) {
            if ( props.selectedTab === "entire") { 
                updateWidgets.entireConfig.reviewList.ratingOptions = newRatingsList;
            } else {
                updateWidgets.individualConfig.reviewList.ratingOptions = newRatingsList;
            }
            try {
                setSaving(true);
                await saveWidgetsConfig(dispatch, updateWidgets);
            } catch(e) {
                console.error(e);
            }
        }
        setSaving(false);
        props.onClose();
    }

    const handleSelect = (value: boolean, index: number) => {
        let newRatingsInfo = ratingsInformation;
        newRatingsInfo[index].selected = value;
        setRatingsInformation(newRatingsInfo);
    }

    const top = props.posY ? `${props.posY}px`:'0';
    const left = props.posX ? `${props.posX}px`:'0';

    return (
        <S.MainContainer ref={componentRef} top={top} left={left}>
            <S.Tittle>
                Show only ratings with:
            </S.Tittle>
            <S.RatingsContainer>
                {ratingsInformation.map((ratingInformation: IRatingInfo, index: number) =>
                <S.RatingRow>
                    <S.RatingColumn>
                        <FilterCheck
                            key={`status`}
                            label={ratingInformation.rating + (ratingInformation.rating>1?" stars":" star")}
                            type="templateStatus"
                            onChange={() => {
                                handleSelect(!ratingInformation.selected, index);
                            }}
                            checked={ratingInformation.selected}
                            styleRoot={{padding: '0px 0px'}}
                            styledCheckbox={{
                                borderRadius: '5px',
                                border: ratingInformation.selected ? 'none' : 'solid 2px rgba(189, 189, 189, 0.5)',
                                background: ratingInformation.selected ?'#2b3a66' : '#fff',
                                width: ratingInformation.selected ? '22px' : '19.5px',
                                height: ratingInformation.selected ? '22px' : '19.5px',
                            }}
                            styleLabel={{
                                fontSize: '14px',
                                color: '#000',
                                marginLeft: '9px'
                            }}
                            stroke='#fff'
                        />
                    </S.RatingColumn>
                </S.RatingRow> 
                )}
            </S.RatingsContainer>
            <S.ErrorMessage>{errorMessage}</S.ErrorMessage>
            <S.Bottom>
                <TCButton
                    type={TC_BUTTON_TYPE.SECONDARY}
                    onClick={() => props.onClose()}
                >
                    Cancel
                </TCButton>
                <TCButton
                    type={TC_BUTTON_TYPE.SECONDARY}
                    onClick={() => saveRatingsInformation()}
                    disabled={saving || ratingsInformation.filter((ratingInfo: IRatingInfo) => ratingInfo.selected).length === 0}
                >
                    Save
                </TCButton>
            </S.Bottom>
        </S.MainContainer>
    )
}

export default SelectRatings;